(function () {
  'use strict';
  var engine = 'https://portrait-animaux.compagnonsdecoeur.fr';
  var shop = 'https://compagnonsdecoeur.fr';
  var productId = '11199196594519';
  var section = document.getElementById('cdc-textile3-product');
  var legacy = document.getElementById('atelier-portrait-animal');
  if (!section || !legacy || section.dataset.productId !== productId || window.location.origin !== shop) return;
  var frame = section.querySelector('iframe');
  if (!frame) return;
  var active = false;
  var requested = false;
  // The new engine may replace the historical atelier only during the first boot of the page:
  // once the customer works in one of them, nothing swaps it behind their back.
  var bootDone = false;
  var disabledStreak = 0;
  var DISABLED_CONFIRMATIONS = 2;
  var manualFallback = false;
  var busy = false;
  var bootTimer = null;
  var requestIds = Object.create(null);
  var id = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

  function showLegacy() {
    active = false;
    requested = false;
    section.hidden = true;
    legacy.hidden = false;
    if (bootTimer) clearTimeout(bootTimer);
    frame.removeAttribute('src');
  }
  function reply(message) {
    if (frame.contentWindow) frame.contentWindow.postMessage(message, engine);
  }
  // 'enabled' | 'disabled' (explicit answer of the engine) | 'unknown' (network error, HTTP error, unreadable answer).
  async function availability() {
    try {
      var response = await fetch(engine + '/api/personalization/textile-public?action=availability&productId=' + productId,
        { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store' });
      if (!response.ok) return 'unknown';
      var data = await response.json();
      if (data.enabled === true && data.productId === productId && data.entryMode === 'product') return 'enabled';
      return data.enabled === false ? 'disabled' : 'unknown';
    } catch (_) { return 'unknown'; }
  }
  function abandonBoot() {
    bootDone = true;
    if (!active) showLegacy();
  }
  async function refresh() {
    if (manualFallback || (bootDone && !active)) return;
    var state = await availability();
    disabledStreak = state === 'disabled' ? disabledStreak + 1 : 0;
    if (!active) {
      if (state === 'enabled' && !requested && !bootDone) {
        requested = true;
        frame.src = engine + '/personnalisation/textile-embed?entryMode=product&productId=' + productId;
        bootTimer = setTimeout(abandonBoot, 20000);
      } else if (requested && state === 'disabled') abandonBoot();
      else if (!requested) bootDone = true;
      return;
    }
    // Active engine: an error never sends the customer back. Only the kill switch does, once it has been
    // confirmed by two consecutive explicit answers (at least 30 s apart).
    if (disabledStreak >= DISABLED_CONFIRMATIONS) showLegacy();
  }
  function matchingLine(cart, resolved) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Cart unavailable');
    return cart.items.find(function (line) {
      return String(line.variant_id) === String(resolved.variantId) && line.quantity === 1 &&
        line.properties && line.properties._cdc_creation_id === resolved.creationId &&
        line.properties._cdc_schema === 'textile-3' &&
        line.properties._cdc_signature === resolved.properties._cdc_signature;
    });
  }
  async function cart() {
    var response = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  async function add(message) {
    if (busy || requestIds[message.requestId] || !active || !id.test(message.creationId) ||
        !id.test(message.requestId) || message.quantity !== 1) return;
    busy = true;
    requestIds[message.requestId] = true;
    var resolved;
    try {
      // The resolve route enforces the switch server-side; the page is never swapped from here.
      if (await availability() === 'disabled') throw new Error('Engine disabled');
      var response = await fetch(engine + '/api/personalization/textile-cart/resolve', {
        method: 'POST', mode: 'cors', credentials: 'include', cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ requestId: message.requestId, creationId: message.creationId, quantity: 1 })
      });
      if (!response.ok) throw new Error('Resolve unavailable');
      resolved = await response.json();
      if (resolved.requestId !== message.requestId || resolved.creationId !== message.creationId ||
          resolved.quantity !== 1 || !resolved.properties ||
          resolved.properties._cdc_creation_id !== message.creationId ||
          resolved.properties._cdc_schema !== 'textile-3' || !resolved.properties._cdc_signature)
        throw new Error('Resolve invalid');
      if (!matchingLine(await cart(), resolved)) {
        try {
          var added = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: resolved.variantId, quantity: 1, properties: resolved.properties }] }) });
          if (!added.ok) throw new Error('Add unavailable');
        } catch (_) { /* The following cart reread resolves a lost response without retrying add. */ }
      }
      if (!matchingLine(await cart(), resolved)) throw new Error('Add unconfirmed');
      reply({ type: 'cdc-textile3-cart-result', version: 1, requestId: message.requestId, status: 'added' });
    } catch (_) {
      reply({ type: 'cdc-textile3-cart-result', version: 1, requestId: message.requestId, status: 'error' });
    } finally { busy = false; }
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== engine || event.source !== frame.contentWindow ||
        !event.data || event.data.version !== 1) return;
    var message = event.data;
    if (message.type === 'cdc-textile3-child-ready' && requested && !active) availability().then(function (state) {
      if (state !== 'enabled' || !requested || bootDone) { abandonBoot(); return; }
      if (bootTimer) clearTimeout(bootTimer);
      bootDone = true;
      active = true;
      legacy.hidden = true;
      section.hidden = false;
      reply({ type: 'cdc-textile3-parent-ready', version: 1 });
    });
    if (message.type === 'cdc-textile3-height' && Number.isFinite(message.height))
      frame.style.height = Math.max(700, Math.min(12000, Math.ceil(message.height))) + 'px';
    if (message.type === 'cdc-textile3-cart-add') add(message);
    if (message.type === 'cdc-textile3-use-legacy') { manualFallback = true; showLegacy(); }
  });
  showLegacy();
  refresh();
  setInterval(refresh, 30000);
})();
